jQuery(function($) {
	$(".range-wrapper").each(function() {

		var rangeSlider 	= $(this).find('.range-slider')[0];
		var rangePreview 	= $(this).find('.range-preview');
		var rangeInput		= $(this).find('.range-input');

		var start 				= $(this).data('start');
		var end 					= $(this).data('end');

		var min 					= $(this).data('min');
		var max 					= $(this).data('max');

		noUiSlider.create(rangeSlider, {
			start: [ Number(start), Number(end) ],
			connect: true,
			range: {
				'min': Number(min),
				'max': Number(max)
			},pips: { // Show a scale with the slider
				mode: 'steps',
				stepped: true,
				density: 5
			}
		});

		var str, left, right;

		rangeSlider.noUiSlider.on('update', function ( values, handle ) {
			if ( handle == 0 ) {
				left = kFormatter(Math.round(values[handle]));
			}
			if ( handle == 1 ) {
				right =  kFormatter(Math.round(values[handle]));
			}
			rangeInput.val(left + ' - ' + right);
			rangePreview.text( left + ' - ' + right );
		});

	});

	function kFormatter(strnum) {
		var str = strnum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		var arr = str.split(',');
		return '$' + arr[0] + "K"
	}

});



// WEBPACK FOOTER //
// ./scripts/range.init.js